import { useIntl as useReactIntl } from 'react-intl'
import { TranslationKey } from './localization/translations'

type UseIntl = () => {
  translate: (textId: TranslationKey, values?: Record<string, string | number>) => string
}

export const useIntl: UseIntl = () => {
  const intl = useReactIntl()
  return {
    translate: (textId, values?: Record<string, string | number>) => {
      return intl.formatMessage({ id: textId }, values)
    }
  }
}

export default useIntl
